import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'insight',
  templateUrl: './insight.component.html',
  styleUrls: ['./insight.component.css']
})
export class InsightComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/containers/insight/insight.component.ts